import React, { useRef, useState } from "react";
import _ from "lodash";
import imagesCss from "../../../assets/styles/images/images.module.scss";
import CreatableSelect from "react-select/creatable";
import { Header, Icon } from "semantic-ui-react";
import ImagesUploader from "./ImagesUploader";

const ImageViewer = ({ imageState, setImageState }) => {
  const fileUploaderRef = useRef(null);
  const [inputValues, setInputValues] = useState({});
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const updateImageOption = (imageKey, updates) => {
    const clonedState = _.cloneDeep(imageState);
    const imageIndex = clonedState.data.template_data.image_options.findIndex(
      (img) => img.image_url === imageKey
    );

    if (imageIndex !== -1) {
      const imageToUpdate = clonedState.data.template_data.image_options[imageIndex];
      clonedState.data.template_data.image_options[imageIndex] = {
        ...imageToUpdate,
        ...updates,
      };
      setImageState(clonedState);
    }
  };

  const handleInputChange = (newValue, imageKey) => {
    setInputValues((prev) => ({
      ...prev,
      [imageKey]: newValue,
    }));
  };

  const handleValueChange = (newValue, imageKey) => {
    const keywordValues = newValue.map((item) => item.value);
    updateImageOption(imageKey, { keywords: keywordValues });
  };

  const handleKeyDown = (event, imageKey) => {
    const inputValue = inputValues[imageKey] || "";
    const image = imageState.data.template_data.image_options.find(
      (img) => img.image_url === imageKey
    );
    const keywords = image?.keywords || [];

    if (!inputValue) return;

    const normalizedValue = inputValue.toLowerCase().replace(/\s+/g, "-");

    if (["Enter", "Tab"].includes(event.key)) {
      const exists = keywords.some(
        (keyword) =>
          keyword.toLowerCase() === inputValue.toLowerCase() ||
          keyword === normalizedValue
      );

      if (!exists) {
        const updatedKeywords = [...keywords, normalizedValue];
        updateImageOption(imageKey, {
          keywords: updatedKeywords,
        });
      }

      setInputValues((prev) => ({
        ...prev,
        [imageKey]: "",
      }));

      event.preventDefault();
    }
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    const fileInput = fileUploaderRef?.current?.querySelector("input[type='file']");
    if (fileInput) {
      fileInput.click();
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#DCE2E3",
      },
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      ":hover": {
        backgroundColor: "transparent",
        color: "inherit",
      },
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
  };

  const handleDelete = (index) => {
    const clonedState = _.cloneDeep(imageState);  
    clonedState.data.template_data.image_options.splice(index, 1);
    setImageState(clonedState);
  };

  return (
    <>
      {imageState?.data?.template_data?.image_options?.map((image, index) => {
        const imageKey = image.image_url;
        const keywords = image.keywords || [];
        const inputValue = inputValues[imageKey] || "";

        return (
          <div className={imagesCss.imageViewerContainer} key={imageKey}>
            <div className={imagesCss.imageViewer}>
              <div onClick={() => handleImageClick(index)} className={imagesCss.imageOverlay}/>
                <div onClick={() => handleImageClick(index)} className={imagesCss.imageViews}>
                 <Icon name="edit" />
                </div>
              <img
                src={`${process.env.REACT_APP_DOMAIN_URL}/image/${image.image_url}`}
                alt="image"
                onClick={() => handleImageClick(index)}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className={imagesCss.imageViewerOverlay}>
              <div className={imagesCss.imageViewerHeader}>
                <Header as="h5">Keywords</Header>
                <Icon name="trash" onClick={() => handleDelete(index)} />
              </div>
              <div className={imagesCss.imageViewerKeywords}>
                <CreatableSelect
                  isClearable
                  isMulti
                  menuIsOpen={false}
                  onChange={(newValue) =>
                    handleValueChange(newValue, imageKey)
                  }
                  onInputChange={(newValue) =>
                    handleInputChange(newValue, imageKey)
                  }
                  onKeyDown={(e) => handleKeyDown(e, imageKey)}
                  inputValue={inputValue}
                  value={keywords.map((k) => ({
                    label: k,
                    value: k,
                  }))}
                  placeholder="Type your keywords and press enter"
                  styles={customStyles}
                  components={{
                    DropdownIndicator: null,
                    ClearIndicator: null,
                  }}
                />
              </div>
            </div>
          </div>
        );
      })}
      <ImagesUploader
        imageState={imageState}
        setImageState={setImageState}
        ref={fileUploaderRef}
        selectedImageIndex={selectedImageIndex}
        setSelectedImageIndex={setSelectedImageIndex}
      />
    </>
  );
};

export default ImageViewer;



// import React, { useRef, useState } from "react";
// import _ from "lodash";
// import imagesCss from "../../../assets/styles/images/images.module.scss";
// import CreatableSelect from "react-select/creatable";
// import { Header } from "semantic-ui-react";
// import ImagesUploader from "./ImagesUploader";

// const ImageViewer = ({ imageState, setImageState }) => {
//   const fileUploaderRef = useRef(null);
//   const [inputValues, setInputValues] = useState({});


//   const updateImageOption = (imageKey, updates) => {
//     const clonedState = _.cloneDeep(imageState);
//     const imageIndex = clonedState.data.template_data.image_options.findIndex(
//       (img) => img.image_url === imageKey
//     );

//     if (imageIndex !== -1) {
//       const imageToUpdate = clonedState.data.template_data.image_options[imageIndex];
//       clonedState.data.template_data.image_options[imageIndex] = {
//         ...imageToUpdate,
//         ...updates,
//       };
//       setImageState(clonedState);
//     }
//   };

//   const handleInputChange = (newValue, imageKey) => {
//     setInputValues((prev) => ({
//       ...prev,
//       [imageKey]: newValue,
//     }));
//   };

//   const handleValueChange = (newValue, imageKey) => {
//     const keywordValues = newValue.map((item) => item.value);
//     updateImageOption(imageKey, { keywords: keywordValues });
//   };

//   const handleKeyDown = (event, imageKey) => {
//     const inputValue = inputValues[imageKey] || "";
//     const image = imageState.data.template_data.image_options.find(
//       (img) => img.image_url === imageKey
//     );
//     const keywords = image?.keywords || [];
  
//     if (!inputValue) return;
  
//     const normalizedValue = inputValue.toLowerCase().replace(/\s+/g, "-");
  
//     if (["Enter", "Tab"].includes(event.key)) {
//       const exists = keywords.some(
//         (keyword) =>
//           keyword.toLowerCase() === inputValue.toLowerCase() ||
//           keyword === normalizedValue
//       );
  
//       if (!exists) {
//         const updatedKeywords = [...keywords, normalizedValue];
//         updateImageOption(imageKey, { keywords: updatedKeywords });
//       }
  
//       setInputValues((prev) => ({
//         ...prev,
//         [imageKey]: "",
//       }));
  
//       event.preventDefault();
//     }
//   };
  

//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       border: "none",
//       boxShadow: "none",
//       "&:hover": {
//         borderColor: "#DCE2E3",
//       },
//     }),
//     multiValueRemove: (provided) => ({
//       ...provided,
//       ":hover": {
//         backgroundColor: "transparent",
//         color: "inherit",
//       },
//     }),
//     dropdownIndicator: () => ({
//       display: "none",
//     }),
//   };

//   return (
//     <>
//       {imageState?.data?.template_data?.image_options?.map((image) => {
//         const imageKey = image.image_url;
//         const keywords = image.keywords || [];
//         const inputValue = inputValues[image.image_url] || "";


//         return (
//           <div className={imagesCss.imageViewerContainer} key={imageKey}>
//             <div className={imagesCss.imageViewer}>
//               <img
//                 src={`http://localhost:3000/image/${image.image_url}`}
//                 alt="image"
//               />
//             </div>
//             <div className={imagesCss.imageViewerOverlay}>
//               <Header as="h5">Keywords</Header>
//               <div className={imagesCss.imageViewerKeywords}>
//                 <CreatableSelect
//                   isClearable
//                   isMulti
//                   menuIsOpen={false}
//                   onChange={(newValue) =>
//                     handleValueChange(newValue, imageKey)
//                   }
//                   onInputChange={(newValue) =>
//                     handleInputChange(newValue, imageKey)
//                   }
//                   onKeyDown={(e) => handleKeyDown(e, imageKey)}
//                   inputValue={inputValue}
//                   value={keywords.map((k) => ({
//                     label: k,
//                     value: k,
//                   }))}
//                   placeholder="Type your keywords and press enter"
//                   styles={customStyles}
//                   components={{
//                     DropdownIndicator: null,
//                     ClearIndicator: null,
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         );
//       })}
//       <ImagesUploader
//         imageState={imageState}
//         setImageState={setImageState}
//         ref={fileUploaderRef}
//       />
//     </>
//   );
// };

// export default ImageViewer;


// import React, { useRef } from "react";
// import imagesCss from "../../../assets/styles/images/images.module.scss";
// import CreatableSelect from "react-select/creatable";
// import { Header } from "semantic-ui-react";
// import ImagesUploader from "./ImagesUploader";

// const ImageViewer = ({ imageState, setImageState }) => {
//   const fileUploaderRef = useRef(null);

//   const handleInputChange = (newValue, imageKey) => {
//     setImageState((prevState) => {
//       const updatedImages = prevState.data.template_data.image_options.map(
//         (img) => {
//           if (img.image_url === imageKey) {
//             return {
//               ...img,
//               inputValue: newValue, // Save temporary input
//             };
//           }
//           return img;
//         }
//       );

//       return {
//         ...prevState,
//         data: {
//           ...prevState.data,
//           template_data: {
//             ...prevState.data.template_data,
//             image_options: updatedImages,
//           },
//         },
//       };
//     });
//   };

//   const handleValueChange = (newValue, imageKey) => {
//     setImageState((prevState) => {
//       const updatedImages = prevState.data.template_data.image_options.map(
//         (img) => {
//           if (img.image_url === imageKey) {
//             return {
//               ...img,
//               keywords: newValue.map((item) => item.value),
//             };
//           }
//           return img;
//         }
//       );

//       return {
//         ...prevState,
//         data: {
//           ...prevState.data,
//           template_data: {
//             ...prevState.data.template_data,
//             image_options: updatedImages,
//           },
//         },
//       };
//     });
//   };

//   const handleKeyDown = (event, imageKey) => {
//     const image = imageState.data.template_data.image_options.find(
//       (img) => img.image_url === imageKey
//     );

//     const inputValue = image?.inputValue || "";
//     const keywords = image?.keywords || [];

//     if (!inputValue) return;

//     const normalizedValue = inputValue.toLowerCase().replace(/\s+/g, "-");

//     switch (event.key) {
//       case "Enter":
//       case "Tab":
//         const exists = keywords.some(
//           (keyword) =>
//             keyword.toLowerCase() === inputValue.toLowerCase() ||
//             keyword === normalizedValue
//         );

//         if (!exists) {
//           const newKeywords = [...keywords, normalizedValue];

//           setImageState((prevState) => {
//             const updatedImages = prevState.data.template_data.image_options.map(
//               (img) => {
//                 if (img.image_url === imageKey) {
//                   return {
//                     ...img,
//                     keywords: newKeywords,
//                     inputValue: "", // Clear input
//                   };
//                 }
//                 return img;
//               }
//             );

//             return {
//               ...prevState,
//               data: {
//                 ...prevState.data,
//                 template_data: {
//                   ...prevState.data.template_data,
//                   image_options: updatedImages,
//                 },
//               },
//             };
//           });
//         } else {
//           // just clear input
//           setImageState((prevState) => {
//             const updatedImages = prevState.data.template_data.image_options.map(
//               (img) => {
//                 if (img.image_url === imageKey) {
//                   return {
//                     ...img,
//                   };
//                 }
//                 return img;
//               }
//             );

//             return {
//               ...prevState,
//               data: {
//                 ...prevState.data,
//                 template_data: {
//                   ...prevState.data.template_data,
//                   image_options: updatedImages,
//                 },
//               },
//             };
//           });
//         }

//         event.preventDefault();
//     }
//   };

//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       border: "none",
//       boxShadow: "none",
//       "&:hover": {
//         borderColor: "#DCE2E3",
//       },
//     }),
//     multiValueRemove: (provided) => ({
//       ...provided,
//       ":hover": {
//         backgroundColor: "transparent",
//         color: "inherit",
//       },
//     }),
//     dropdownIndicator: () => ({
//       display: "none",
//     }),
//   };

//   return (
//     <>
//       {imageState?.data?.template_data?.image_options?.length > 0 &&
//         imageState.data.template_data.image_options.map((image) => {
//           const imageKey = image.image_url;
//           const keywords = image.keywords || [];
//           const inputValue = image.inputValue || "";

//           return (
//             <div className={imagesCss.imageViewerContainer} key={imageKey}>
//               <div className={imagesCss.imageViewer}>
//                 <img
//                   src={`http://localhost:3000/image/${image.image_url}`}
//                   alt="image"
//                 />
//               </div>
//               <div className={imagesCss.imageViewerOverlay}>
//                 <Header as="h5">Keywords</Header>
//                 <div className={imagesCss.imageViewerKeywords}>
//                   <CreatableSelect
//                     isClearable
//                     isMulti
//                     menuIsOpen={false}
//                     onChange={(newValue) =>
//                       handleValueChange(newValue, imageKey)
//                     }
//                     onInputChange={(newValue) =>
//                       handleInputChange(newValue, imageKey)
//                     }
//                     onKeyDown={(e) => handleKeyDown(e, imageKey)}
//                     inputValue={inputValue}
//                     value={keywords.map((k) => ({
//                       label: k,
//                       value: k,
//                     }))}
//                     placeholder="Type your keywords and press enter"
//                     styles={customStyles}
//                     components={{
//                       DropdownIndicator: null,
//                       ClearIndicator: null,
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       <ImagesUploader
//         imageState={imageState}
//         setImageState={setImageState}
//         ref={fileUploaderRef}
//       />
//     </>
//   );
// };

// export default ImageViewer;
